module.exports = __webpack_public_path__ + "static/media/Like_Detector.9c9dbdfb.png";